import axios from "axios";

const prepareData = (data) => {return {store_overalls_status:data}}

// Plural Actions
export const GET_STORE_OVERALLS_STATUSES = "get_store_overalls_statuses";
export const getStoreOverallsStatuses = () => {
	const url = `/store/overalls/statuses.json`
	const request = axios.get(url);
	return {
		type: GET_STORE_OVERALLS_STATUSES,
		payload: request
	};
};


// Singular Actions
export const CREATE_STORE_OVERALLS_STATUS = "create_store_overalls_status";
export const createStoreOverallsStatus = (data) => {
	const url = `/store/overalls/statuses.json`
	const request = axios({method: "post",url: url,data: prepareData(data)});
	return {
		type: CREATE_STORE_OVERALLS_STATUS,
		payload: request
	};
};

export const GET_STORE_OVERALLS_STATUS = "get_store_overalls_status";
export const getStoreOverallsStatus = (id) => {
	const url = `/store/overalls/statuses/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_STORE_OVERALLS_STATUS,
		payload: request
	};
};

export const UPDATE_STORE_OVERALLS_STATUS = "update_store_overalls_status";
export const updateStoreOverallsStatus = (id,data) => {
	const url = `/store/overalls/statuses/${id}.json`
	const request = axios({method: "patch",url: url,data: prepareData(data)});
	return {
		type: UPDATE_STORE_OVERALLS_STATUS,
		payload: request
	};
};

export const DESTROY_STORE_OVERALLS_STATUS = "destroy_store_overalls_status";
export const destroyStoreOverallsStatus = (id) => {
	const url = `/store/overalls/statuses/${id}.json`
	const request = axios({method: "delete",url: url});
	return {
		type: DESTROY_STORE_OVERALLS_STATUS,
		payload: request
	};
};
